import React from "react"
import { HistoInvestissementItem } from "../../model/dto/histo-investissement-item"
import { ProjetListItem } from "../../model/dto/projet-list-item"
import { BankProvider } from "../../model/entities/bank-provider"
import { HistoInvestissementProjet } from "../../model/entities/histo-investissement-projet"
import { InvestWorkflow } from "../../model/entities/invest-workflow"
import { MontantPaiementPane } from "./montant-paiement-pane"
import { MoyenPaiementPane } from "./moyen-paiement-pane"

interface Props {
    projet?: ProjetListItem,
    montant?: number | string,
    montantPercuValue?: string,
    isContratCheckedValue?: boolean,
    activeStepKey: string,
    selectedProvider?: BankProvider,
    numeroReponseTestList?: number[],
    score?: number,
    userInvestissementHistoryList?: HistoInvestissementItem[],
    projetInvestissementHistoryList?: HistoInvestissementProjet[],
    errorMessage?: string,
    isErrorDisplayed?: boolean,
    onValidateMontant?: (montant: number, montantPercu: string, isContratChecked: boolean, isNextStep?: boolean) => void
    onSelectBranch?: (provider: BankProvider) => void,
    onSubmitImpossible?: (message: string) => void
}

export function InvestmentPaneSelection({
    projet, 
    montant, 
    montantPercuValue,
    isContratCheckedValue,
    activeStepKey, 
    numeroReponseTestList, 
    score, 
    userInvestissementHistoryList, 
    projetInvestissementHistoryList, 
    selectedProvider, 
    errorMessage,
    isErrorDisplayed,
    onValidateMontant, 
    onSelectBranch,
    onSubmitImpossible
}: Props) {
    
    return(
        <>
        {activeStepKey === InvestWorkflow.MONTANT && (
                <MontantPaiementPane
                    projet={projet}
                    montant={montant}
                    montantPercuValue={montantPercuValue}
                    isContratCheckedValue={isContratCheckedValue}
                    numeroReponseTestList={numeroReponseTestList}
                    score={score}
                    userInvestissementHistoryList={userInvestissementHistoryList}
                    projetInvestissementHistoryList={projetInvestissementHistoryList}
                    onValidateMontant={onValidateMontant}
                />
            )}
            {activeStepKey === InvestWorkflow.PAIEMENT && (
                <MoyenPaiementPane
                    montant={montant}
                    projetId={projet?.Id}
                    errorMessage={errorMessage}
                    isErrorDisplayed={isErrorDisplayed}
                    onSelectBranch={onSelectBranch}
                    onSubmitImpossible={onSubmitImpossible}
                />
            )}
        </>
    )
}